interface LoggerConfig {
  enableConsole: boolean;
  enableSentry: boolean;
}

class Logger {
  private config: LoggerConfig;

  constructor(
    config: LoggerConfig = { enableConsole: true, enableSentry: true }
  ) {
    this.config = config;
  }

  log(message: string, ...args: any[]) {
    if (this.config.enableConsole) {
      // eslint-disable-next-line no-console
      console.log(message, ...args);
    }
  }

  error(message: string, error?: any) {
    if (this.config.enableConsole) {
      // eslint-disable-next-line no-console
      console.error(message, error);
    }
  }

  warn(message: string, ...args: any[]) {
    if (this.config.enableConsole) {
      // eslint-disable-next-line no-console
      console.warn(message, ...args);
    }
  }

  info(message: string, ...args: any[]) {
    if (this.config.enableConsole) {
      // eslint-disable-next-line no-console
      console.info(message, ...args);
    }
  }

  debug(message: string, ...args: any[]) {
    if (this.config.enableConsole && process.env.NODE_ENV === 'development') {
      // eslint-disable-next-line no-console
      console.debug(message, ...args);
    }
  }
}

// Create logger instance with environment-based configuration
const isDevelopment = process.env.NODE_ENV === 'development';
const isProduction = process.env.NODE_ENV === 'production';

export const logger = new Logger({
  enableConsole: isDevelopment || !isProduction, // Allow console in dev, disable in production
  enableSentry: true,
});

export default logger;
